import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./HomePage";
import ProductDetail from "./ProductDetail";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";




import AllProductsPage from "./AllProductsPage"; // bu yol doğruysa çalışır


function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/all-products" element={<AllProductsPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}


export default App;